import { useState } from 'react';
import { pageDisplayOptions } from '../../types/pageDispalyOptions.ts';
import { LiveGraphSettings, timeFrameOptions } from './liveGraphSettings.ts';



const defaultSettings: LiveGraphSettings = {
    visibleShifts: ['morning', 'evening', 'night'],
    timeFrame: timeFrameOptions[1],
    excludeWeekends: false,
    smoothingAmount: 1,
    resolution: 'halfHour',
    valueType: 'availability',
    oeeComponents: ['availability', 'quality', 'performance'],
    pageDisplay: pageDisplayOptions[0],
};


export function useDisplayOptions() {
    const [settings, setSettings] = useState<LiveGraphSettings>(loadOptions());


    function loadOptions(): LiveGraphSettings {
        const options = localStorage.getItem('oeeGraphOptions');
        return options ? JSON.parse(options) : defaultSettings;
    }

    function handleSettingsChange(newOptions: LiveGraphSettings) {
        setSettings(newOptions);
        localStorage.setItem('oeeGraphOptions', JSON.stringify(newOptions));
    }

    return {
        settings,
        setSettings: handleSettingsChange
    }
}
